/**
 * Query string a partir de un objeto de params, para las grillas que piden sus datos al
 * backend armando la URL a mano (26 grillas; tickets tenía 73 concatenaciones).
 *
 * DOS DECISIONES QUE PARECEN DETALLE Y NO LO SON:
 *
 * 1. **Las claves sin valor se mandan vacías, no se omiten.** Es lo que las grillas ya hacen
 *    y de lo que depende el backend: `TicketGridNew::scopeUserSelectedFilters` hace
 *    `extract($filters)` e inicializa solo cuatro variables antes, así que cambiar qué claves
 *    llegan es cambiar el contrato. Omitir vacíos sería más lindo y es para otra card.
 *
 * 2. **Los valores se encodean siempre.** Hoy la mayoría viaja crudo: un `&` en un filtro de
 *    texto libre inyecta un parámetro que nadie mandó, y un `#` trunca el resto de la URL.
 *    `encodeURIComponent` sobre un valor ya encodeado lo escaparía dos veces, así que quien
 *    migre una grilla tiene que sacar los `encodeURIComponent` que ya tenga en sus valores.
 *
 * `null` y `undefined` se mandan como vacío: sin eso, un estado incompleto termina mandando
 * literalmente `&estadoSort=undefined`, que es lo que pasaba antes en tickets.
 */
export const buildQueryString = (params) => {
	const claves = Object.keys(params || {});
	if (claves.length === 0) return '';

	const partes = claves.map((clave) => {
		const valor = params[clave];
		const texto = valor === null || valor === undefined ? '' : String(valor);
		return encodeURIComponent(clave) + '=' + encodeURIComponent(texto);
	});

	return '?' + partes.join('&');
};

export default buildQueryString;
